import React from 'react';
import './Display.css'

export default function Display (props) {

    return (
        <div className="display-container">
           <div className="display">
               <div className="concat-char">{/\d/.test(props.result) ? props.concatChar+"="+props.result : props.concatChar}</div>
               <div className="current-char">{/\d/.test(props.result) ? props.result : props.currentChar}</div>
           </div>
        </div>
    )
    
} 